<div class="option-content-particularity">
    <span class="option-title">Convenio</span>

    <div class="actions">
        <input type="checkbox" [checked]="getIsAgreement()" (click)="setAgreement()" class="checkbox" />
    </div>
</div>